import { httpClient } from "./httpClient";

type InfrastructureApplication = {
  id: number;
  name: string;
};

type Data = {
  infrastructureApps: InfrastructureApplication[];
};

export async function getInfrastructureApplications(
  application: number
): Promise<InfrastructureApplication[]> {
  try {
    const { data } = await httpClient.get<Data>(
      `/api/v1/infrastructure-applications/search?appId=${application}`
    );
    return data.infrastructureApps;
  } catch (error) {
    throw error;
  }
}
